import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useRef } from 'react';
import { makeSelectBox } from '../redux/features/boxes/box';
import { AppState } from '../redux/reducers';
import { selectIsAllOutOfStock } from '../redux/features/products/reducers/products';
import sharedAction from '../redux/features/shared/actions';

/**
 * Show pop up when all product is sold
 */
export function useShowSoldoutNotification(boxId = 'soldoutalert') {
  const dispatch = useDispatch();
  const selectBox = useMemo(makeSelectBox, [boxId]);
  const { isAllSold, msg } = useSelector((state: AppState) => ({
    isAllSold: selectIsAllOutOfStock(state),
    msg: selectBox(state, boxId),
  }));

  const showOnce = useRef(false);
  const content = msg?.content;
  const shouldShow = isAllSold && content;
  useEffect(() => {
    if (shouldShow && !showOnce.current) {
      showOnce.current = true;
      dispatch(sharedAction.notifyBox(content));
    }
  }, [dispatch, content, shouldShow]);

  return showOnce.current;
}
